import { render, staticRenderFns } from "./LabelDropdown.vue?vue&type=template&id=ca64b072"
import script from "./LabelDropdown.vue?vue&type=script&lang=js"
export * from "./LabelDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports